import Button from 'components/common/Buttons';
import { useDispatch, useSelector } from 'react-redux';
import { selectisContactFormOpen, setContactFormOpenOpen } from 'store/slices/UI-Slice';


const UseCaseNavItem = ({ navTitle, navDesc, navBtnText, navLink = null }) => {
    const dispatch = useDispatch()
    const isOpen = useSelector(selectisContactFormOpen);

    const handlePopupClick = () => {
        dispatch(setContactFormOpenOpen(!isOpen))
        document.documentElement.classList.toggle('unscrolled');
    };
    return (
        <div onClick={handlePopupClick} className='usecase-cases-navitem'>
            <div className='description1'>{navTitle}</div>
            <div className='body1'>{navDesc}</div>
            <Button text={navBtnText} type='white' />
        </div>
    );
}

export default UseCaseNavItem; 